import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { IPageMeta, IPrice, IPriceSend } from "@/services/interfaces";

const initialMeta = {
  h1: "",
  title: "",
  breadcrumbs: [],
};

@Module({
  name: "prices",
  namespaced: true,
})
export default class Prices extends VuexModule {
  prices: IPrice[] = [];
  meta: IPageMeta = initialMeta;
  currentPrice: number | "hide" = 0;

  get getPrices() {
    return this.prices;
  }

  get getMeta() {
    return this.meta;
  }

  get getCurrentPrice() {
    return this.currentPrice;
  }

  get getHidePrice() {
    return this.getCurrentPrice === "hide";
  }

  get getCurrentData() {
    return this.prices.find((item) => item.id === this.currentPrice);
  }

  @Mutation
  setPrices(prices: IPrice[]) {
    this.prices = prices;
  }

  @Mutation
  setMeta(meta: IPageMeta) {
    this.meta = meta;
  }

  @Mutation
  setCurrentPrice(data: number | "hide") {
    this.currentPrice = data;
    localStorage.setItem("currentPrice", JSON.stringify(data));
  }

  @Action
  async requestPrices(): Promise<void> {
    try {
      const res = await axios({
        method: "GET",
        url: "/api/prices",
      });
      if (res.data?.data) this.setPrices(res.data?.data.prices);
      if (res.data?.meta) this.setMeta(res.data?.meta);
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }

  @Action
  async sendPrice(data: IPriceSend): Promise<void> {
    try {
      const res = await axios({
        method: "POST",
        url: data.id ? `/api/prices/${data.id}` : "/api/prices/",
        data,
      });
      if (res.data?.data) this.setPrices(res.data?.data.prices);
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }

  @Action
  async deletePrice(id: number): Promise<void> {
    try {
      const res = await axios({
        method: "DELETE",
        url: `/api/prices/${id}`,
      });
      if (res.data?.data) this.setPrices(res.data?.data.prices);
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }
}
